import React from "react";
import { Link } from "react-router-dom";
import BackupArticle from "../components/BackupArticle";
import { usePageTitle } from "../hooks/usePageTitle";

function BackupPage() {
  usePageTitle("Sauvegardes, PRA & PRS");
  return (
    <div className="terraform-page">
      <Link to="/blog" className="article-back-btn">← Blog</Link>
      <BackupArticle />
    </div>
  );
}

export default BackupPage;
